var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { sortedSet } from '../../../utils/mobx/decorators/customComputed';
import { uniq } from '../../../utils/helper/lodash_replacements';
export class AspectContentScoped {
    parent;
    scope;
    constructor(parent, scope) {
        makeObservable(this);
        this.parent = parent;
        this.scope = scope;
    }
    get aspectContent() {
        return this.parent;
    }
    get aspect() {
        return this.parent.aspect;
    }
    allActiveOfType(type) {
        return this.scope.aspectKey(type).keyActive.activeTraits;
    }
    allEnabledOfType(type) {
        return this.scope.aspectKey(type).keyEnabled.enabledTraits;
    }
    get activeContentAts() {
        return uniq([
            ...this.allActiveOfType('image'),
            ...this.allActiveOfType('text'),
            ...this.allActiveOfType('box'),
            ...this.allActiveOfType('table'),
            ...this.allActiveOfType('gap'),
            ...this.allActiveOfType('video'),
            ...this.allActiveOfType('audio'),
            ...this.allActiveOfType('sound'),
            ...this.allActiveOfType('childFromSkeleton'),
            ...this.allActiveOfType('childFromAspectName'),
        ]).sort((at1, at2) => {
            if (at1.valueOf.contentOrderPosition !== at2.valueOf.contentOrderPosition) {
                return at1.valueOf.contentOrderPosition - at2.valueOf.contentOrderPosition;
            }
            return at2.prio - at1.prio;
        });
    }
    get hasContent() {
        return this.activeContentAts.length > 0;
    }
    get allEnabledTextBasisStringsJoined() {
        return this.allEnabledOfType('text')
            .map(text => text.textBasis)
            .join(' ');
    }
    primaryOfKey(key) {
        if (this.allActiveOfType(key).length > 0) {
            return this.allActiveOfType(key)[0];
        }
        return this.addedOfKey(key);
    }
    hasPrimary(key) {
        return this.allActiveOfType(key).length > 0;
    }
    addedOfKey(key) {
        return this.aspect.aspectAttached.toAttached(this.parent.local.addedTraitOfKey(key));
    }
}
__decorate([
    sortedSet
], AspectContentScoped.prototype, "activeContentAts", null);
